let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("221z2")).then(() => parcelRequire('7qCqp'));